<template lang="pug">
  erp-view(id="Login" ref="Login" title="Inicio de Sesión" blank hide-header-title hide-header-action background-color="#4b7197 !important")
    template(slot="content")
      Noticias(ref="NoticiasPop")
      br
      br
      dx-validation-group.login(ref="grupoValidacion")
        .ed-grid.s-grid-1.m-grid-5.rows-gap.gap-1
          .login-body.m-x-3.m-cols-1.s-x-1
            .ed-grid.rows-gap.gap-1
              .login-header
                img(:src="require('@/assets/logo.png')" contain height="80")
              dx-text-box(:value.sync="usuario" placeholder="Usuario" :onEnterKey="iniciarSesion")
                dx-validator
                  dx-required-rule(message="Usuario es requerido")
              dx-text-box(:value.sync="contrasena" placeholder="Contraseña" :show-clear-button="true" mode="password" :onEnterKey="iniciarSesion")
                dx-validator
                  dx-required-rule(message="Contraseña es requerida")
            
              dx-button#button(:use-submit-behavior="true" text="Iniciar Sesión" @click="iniciarSesion" type="default")
                
              //dx-button#button(:use-submit-behavior="true" text="Olvidé mi contraseña" type="default" styling-mode="text" @click="olvideContrasena")
</template>
<script>
import Autenticacion from "@/api/Autenticacion.js"; 
import BrowserScan from "@/components/BrowserScan";
export default {
  data: () => ({
    usuario: "",
    contrasena: "",
    dispositivo: "none"
  }),
  methods: {
    iniciarSesion() {
      let grupoValidacion = this.$refs["grupoValidacion"].instance;
      if (!grupoValidacion.validate().isValid) {
        return;
      }
      this.$refs.Login.wait();

      Autenticacion.autenticar(this.usuario, this.contrasena, this.dispositivo)
        .then(res => {
          if (res) {
            let jwt = res.headers.authorization;
            this.$store.commit("seguridad/setToken", jwt);
            this.$router.replace({ name: "Aplicaciones" });
            this.$refs.Login.wait(false);
          }
        })
        .catch(err => {
          this.$msg.handleError(err);
          this.$refs.Login.wait(false);
        });
    },
    olvideContrasena() {
      this.$router.push({ name: "OlvideContrasena" });
    }
  },
  created() {
    this.dispositivo =
      process.env.NODE_ENV == "development" ? "dev" : BrowserScan.isMobile() ? "movil" : "web";
  }
};
</script>
<style scoped>
* {
  font-size: 12px !important;
}

.logo {
  width: 172px;
  max-height: 122px;
  border: 1px solid rgba(191, 191, 191, 0.25);
  float: left;
  margin: 0 30px 10px 0;
}
#button {
  display: block;
  font-weight: 500;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-header .title {
  color: #2068af;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
}

.login-body {
  border: 1px dotted lightgrey;
  background-color: white;
  border-radius: 5px;
  padding: 1.5em;
}
</style>
